import { Button, Popconfirm, Space } from "antd";
import { DeleteFilled, EditFilled, CheckCircleTwoTone, CloseCircleTwoTone } from "@ant-design/icons";

const ExpandedRow = {
    expandedRowRender: (record) => {
        return (
            <div>
                <p>Comentario: {record.comment}</p>
                <p>Fecha de inicio: {record.dateStart}</p>
                <p>Fecha de final: {record.dateFinished}</p>
            </div>
        );
    },
};

const propsColumnsExtraResource = () => {
    return {
        size: "large",
        scroll: { x: "100vh", y: null },
        bordered: true,
        expandable: ExpandedRow,
    };
};

const columnsType = (editAction, deleteAction, filter = { isSuperAdmin: false }) => {
    return [
        {
            title: "Afecta",
            dataIndex: "doesHaveImpact",
            key: "doesHaveImpact",
            render: (text) => <span>{text ? <CheckCircleTwoTone twoToneColor="green" /> : <CloseCircleTwoTone twoToneColor="red" />}</span>,
        },
        {
            title: "Área",
            dataIndex: "area",
            key: "area",
            sorter: (a, b) => {
                if (a.email < b.email) {
                    return -1;
                }
                if (a.email > b.email) {
                    return 1;
                }
                return 0;
            },
            render: (text) => <span style={{ textTransform: "lowercase" }}>{text}</span>,
        },
        {
            title: "Recursos extras",
            dataIndex: "extraresources",
            key: "extraresources",
            sorter: (a, b) => {
                if (a.rol < b.rol) {
                    return -1;
                }
                if (a.rol > b.rol) {
                    return 1;
                }
                return 0;
            },
            render: (text) => <span style={{ textTransform: "lowercase" }}>{text}</span>,
        },
        {
            title: "Tipo",
            dataIndex: "typeextraresources",
            key: "typeextraresources",
            render: (text) => {
                let name = text;
                if (text === "PROVEDOR") {
                    name = "PROVEEDOR";
                }
                return (
                    <>
                        <span style={{ textTransform: "lowercase" }}>{name}</span>
                    </>
                );
            },
        },
        {
            title: "Cantidad",
            dataIndex: "amount",
            key: "amount",
        },
        {
            title: "Moneda",
            dataIndex: "currency",
            key: "currency",
        },
        {
            title: "Horas",
            dataIndex: "hours",
            key: "hours",
        },
        {
            title: "Action",
            key: "action",
            render: (_, record) => (
                <Space size="middle">
                    {filter.isSuperAdmin && (
                        <>
                            <Button
                                type="text"
                                icon={<EditFilled />}
                                onClick={() => {
                                    editAction(record);
                                }}
                            />
                            <Popconfirm title="¿Seguro eliminar?" onConfirm={() => deleteAction(record.key)}>
                                <Button type="text" icon={<DeleteFilled />} />
                            </Popconfirm>
                        </>
                    )}
                </Space>
            ),
        },
    ];
};

export const columnsExtraResource = (editAction, deleteAction, filter = { isSuperAdmin: false }) => {
    const columns = columnsType(editAction, deleteAction, filter);
    const props = propsColumnsExtraResource();
    return {
        columns,
        props,
    };
};
